var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","small":""},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('v-icon',{attrs:{"id":"RTE__command__redo"}},[_vm._v("mdi-redo")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }